//ReportType Filters
import ActivityResultsReportFilter from 'presentation/pages/reports/filters/activity-results-report-filter'
import MediaAccessHistoryReportFilter from 'presentation/pages/reports/filters/media-access-history-report-filter'
import ClassroomAttendancesReportFilter from '../filters/classroom-attendance-report-filter';
import DisciplineAttendancesReportFilter from '../filters/discipline-attendance-report-filter';

export const REPORT_TYPE_EMPTY = -1;
export const REPORT_TYPE_ACTIVITY_RESULTS = 1;
export const REPORT_TYPE_MEDIA_ACCESS_HISTORY = 2;
export const REPORT_TYPE_CLASSROOM_ATTENDANCE = 3;
export const REPORT_TYPE_DISCIPLINE_ATTENDANCE = 4;

export const getReportTypes = () => {
    return [
        {
            id: REPORT_TYPE_EMPTY,
            name: 'Selecione',
        },
        {
            id: REPORT_TYPE_ACTIVITY_RESULTS,
            name: 'Relação de atividades x Aproveitamento',
        },
        {
            id: REPORT_TYPE_MEDIA_ACCESS_HISTORY,
            name: 'Acesso aos materiais',
        },
        {
            id: REPORT_TYPE_CLASSROOM_ATTENDANCE,
            name: 'Frequência por dia',
        },
        {
            id: REPORT_TYPE_DISCIPLINE_ATTENDANCE,
            name: 'Frequência por disciplina',
        }

    ]
}

export const renderReportFilters = (reportType, params) => {
    let output = null;
    var reportFilters = [
        {
            key: REPORT_TYPE_ACTIVITY_RESULTS,
            element: <ActivityResultsReportFilter {...params} />
        },
        {
            key: REPORT_TYPE_MEDIA_ACCESS_HISTORY,
            element: <MediaAccessHistoryReportFilter {...params} />
        },
        {
            key: REPORT_TYPE_CLASSROOM_ATTENDANCE,
            element: <ClassroomAttendancesReportFilter {...params} />
        },
        {
            key: REPORT_TYPE_DISCIPLINE_ATTENDANCE,
            element: <DisciplineAttendancesReportFilter {...params} />
        }
    ];
    if (reportFilters.filter(x => x.key == reportType)[0]) {
        output = reportFilters.filter(x => x.key == reportType)[0].element;
    }
    return output;
}

const reportFunctions = {
    getReportTypes,
    renderReportFilters
}

export default reportFunctions;